import axios from 'axios';
import { toast } from 'react-toastify';
import { GroupType, TagMemberType } from 'type/type';

const whapiPath = '/api';
const whapiBase = process.env.NODE_ENV === 'development' ? 'https://whapi.api.aotearoa.energy' : '';
const whapiUrl = `${whapiBase}${whapiPath}`;

export const fetchGroupsData = async () => {
  return await axios.get<{ data: GroupType[] }>(`${whapiUrl}/getGroups`);
};

export const fetchTagNames = async () => {
  return await axios.get<{
    tags: string[];
  }>(`${whapiUrl}/getTags`);
};
export const fetchTagMembers = async (tag: string) => {
  return await axios.get<TagMemberType[]>(`${whapiUrl}/membersOf/${tag}`);
};

interface SubmitMessageProps {
  tag: string;
  message: string;
  advance?: string[];
  excluded?: string[];
}
// Messages
export const submitMessageByTagAdvance = async (data: SubmitMessageProps) => {
  return await axios.post(`${whapiUrl}/sendToTag/${data.tag}/text`, {
    message: data.message,
    advance: data.advance,
  });
};
export const submitMessageByTagExclude = async (data: SubmitMessageProps) => {
  return await axios.post(`${whapiUrl}/sendToTag/${data.tag}/text`, {
    message: data.message,
    exclude: data.excluded,
  });
};

export const submitMessageByTag = async (data: SubmitMessageProps) => {
  return await axios.post(`${whapiUrl}/sendToTag/${data.tag}/text`, {
    message: data.message,
  });
};

// Images
interface SubmitImageProps {
  tag: string;
  image: string | undefined;
  advance?: string[];
  excluded?: string[];
}
export const submitImageByTagAdvance = async (data: SubmitImageProps) => {
  return data.image
    ? await axios.post(`${whapiUrl}/sendToTag/${data.tag}/image`, {
        message: data.image,
        advance: data.advance,
      })
    : toast.error('Image is not selected');
};
export const submitImageByTagExclude = async (data: SubmitImageProps) => {
  return data.image
    ? await axios.post(`${whapiUrl}/sendToTag/${data.tag}/image`, {
        message: data.image,
        exclude: data.excluded,
      })
    : toast.error('Image is not selected');
};

export const submitImageByTag = async (data: SubmitImageProps) => {
  return data.image
    ? await axios.post(`${whapiUrl}/sendToTag/${data.tag}/image`, {
        message: data.image,
      })
    : toast.error('Image is not selected');
};

export const syncGroupsFn = async () => {
  return await axios.get(`${whapiUrl}/syncGroups`);
};
